import type {
  PostDocumentRequestType,
  PostDocumentResponseType,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const postDocuments = async (params: PostDocumentRequestType) => {
  const url = `/api/v2/documents`;
  const response = await apiAuthClient.post<PostDocumentResponseType>(
    url,
    params,
  );

  return response.data;
};
